import styled from '@emotion/styled';
import Text from '@molecules/Text';
import { ThemeColors } from '@theme/foundations/colors';
import ScreenSize from '../../../constants/screen-sizes';

export const StyledRoomCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px;
  gap: 16px;

  .text-decoration {
    text-decoration-line: line-through;
  }

  .text-underline {
    text-decoration-line: underline;
  }

  .book-button {
    border: 2px solid #32C0A0;
    font-weight: 500;
    font-size: 14px;
  }

  .description-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
            line-clamp: 3; 
    -webkit-box-orient: vertical;
  }

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    flex-direction: column;
    gap: 20px;
    padding: 0px;
  }
`;

export const StyledRoomCardGalleryContainer = styled.div`
  position: relative;
  width: 340px;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: 100%;
  }
`;

export const StyledRoomInfoContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    padding: 0 16px 16px 16px;
  }
`;

export const StyledDescription = styled(Text)`
  margin-top: 24px;
`;

export const StyledFooter = styled.div`
  display: flex;
  border-top: 1px solid #DDE0E4;
  justify-content: center;
  padding: 8px;
`;

export const StyledImageMask = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3));
  background-blend-mode: normal, multiply;
  border-radius: 8px;
`;

export const StyledMark = styled(Text)`
  position: absolute;
  top: 6px;
  left: 6px;
  background-color: ${ThemeColors.error[500]};
  border-radius: 24px;
  padding: 2px 12px;
`;
